import { combineReducers } from "redux";

import cpeForm from "./cpeForm/cpeFormSlice";
import requestForm from "./requestForm/requestFormSlice";
import requestLines from "./requestLine/requestLineSlice";
import leaveLines from "./leaveLine/leaveLineSlice";
import attachments from "./attachment/attachmentsSlice";
import formTeam from "./formTeam/formTeamSlice";
import balance from "./balance/balanceSlice";
import myHistory from "./myHistory/myHistorySlice";
import parentForm from "./parentForm/parentFormSlice";
import person from "./person/personSlice";
import formApproval from "./formApproval/formApprovalSlice";
import leaveManager from "./leaveManager/leaveManagerSlice";
import admin from "./admin/adminSlice";

export default combineReducers({
	cpeForm,
	requestForm,
	requestLines,
	leaveLines,
	attachments,
	formTeam,
	balance,
	myHistory,
	parentForm,
	person,
	formApproval,
	leaveManager,
	admin,
});
